import styled, { keyframes } from 'styled-components';

import { getThemeProp } from 'theme';

const loadingAnimation = keyframes`
from {
      left: -40%;
    }

    to {
      left: 100%;
    }
`;

export const StyledContainer = styled.div`
  background-color: ${getThemeProp('colors.hawkesBlue')};
  height: 4px;
  margin-top: 22px;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const COMPLETED_PART_COLOR_MAP = {
  red: 'carnationRed',
  blue: 'chetwodeBlue2',
};

export const StyledCompletedPart = styled.span`
  animation: linear infinite;
  animation-duration: 2s;
  animation-name: ${loadingAnimation};
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 53%;

  ${props => {
    const backgroundColorName =
      props.color === 'red'
        ? COMPLETED_PART_COLOR_MAP.red
        : COMPLETED_PART_COLOR_MAP.blue;

    return `
      background-color:  ${getThemeProp(`colors.${backgroundColorName}`)(
        props,
      )};
    `;
  }}
`;
